import CustomMultiSelect from "../Utilities/CustomMultiSelect";
import {useState} from "react";
import CategorySelect from "./Category/CategorySelect";
import BrandSelect from "./Category/BrandSelect";
import ShopSelect from "../Shop/ShopSelect";
import EmployeeSelect from "../Common/EmployeeSelect";

export default function ProductFilterBox({SetFilterQuery}) {

    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedStockStatus, setSelectedStockStatus] = useState('');
    const [selectedShop, setSelectedShop] = useState('');
    const [selectedCreatedBy, setSelectedCreatedBy] = useState('');
    const [selectedUpdatedBy, setSelectedUpdatedBy] = useState('');
    const [selectedPublishedBy, setSelectedPublishedBy] = useState('');
    const [filterResetKey, setFilterResetKey] = useState(0);
    const handleMultiSelectCategory = (_selectedCategory) => {
        setSelectedCategory(_selectedCategory)
    }

    const handleMultiSelectBrand = (selectedBrand) => {
        setSelectedBrand(selectedBrand?.[0]?.value)
    }

    const handleMultiSelectShop = (selectedShop) => {
        setSelectedShop(selectedShop?.map(item => item._id) ?? [])
    }

    const getSelectedEmployeeId = (employees) => employees?.[0]?._id ?? '';

    const clearFilters = () => {
        setSelectedCategory([]);
        setSelectedBrand([]);
        setSelectedStatus('');
        setSelectedStockStatus('');
        setSelectedShop('');
        setSelectedCreatedBy('');
        setSelectedUpdatedBy('');
        setSelectedPublishedBy('');
        setFilterResetKey((key) => key + 1);
        SetFilterQuery({});
    };

    return (
        <div className={``}>
            <div className="pt-3 pb-4">
                <div className="main-content p-3">
                    <div key={filterResetKey} className="grid-form text-xs grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 2xl:grid-cols-10 gap-3 2xl:gap-4 2xl:gap-y-5">
                        <div>
                            <label>
                                <span className="block">دسته بندی</span>

                                <CategorySelect
                                    assignItem={handleMultiSelectCategory}
                                    placeholder="انتخاب دسته"
                                />

                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">برند</span>

                                <BrandSelect
                                    assignItem={handleMultiSelectBrand}
                                    placeholder="انتخاب برند"
                                />

                            </label>
                        </div>
{/*                         <div>
                            <label>
                                <span className="block">ایجاد توسط</span>
                                <select className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">پیشفرض</option>
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">بروزرسانی توسط</span>
                                <select className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">پیشفرض</option>
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">انتشار توسط</span>
                                <select className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">پیشفرض</option>
                                </select>
                            </label>
                        </div> */}

                        <div>
                            <label>
                                <span className="block">ایجاد کننده</span>
                                <EmployeeSelect
                                    multiple={false}
                                    placeholder="انتخاب ایجاد کننده"
                                    assignItem={(employees) => setSelectedCreatedBy(getSelectedEmployeeId(employees))}
                                />
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">بروز رسانی کننده</span>
                                <EmployeeSelect
                                    multiple={false}
                                    placeholder="انتخاب بروز رسانی کننده"
                                    assignItem={(employees) => setSelectedUpdatedBy(getSelectedEmployeeId(employees))}
                                />
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">انتشار دهنده</span>
                                <EmployeeSelect
                                    multiple={false}
                                    placeholder="انتخاب انتشار دهنده"
                                    assignItem={(employees) => setSelectedPublishedBy(getSelectedEmployeeId(employees))}
                                />
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">وضعیت</span>
                                <select
                                    onChange={ (e) => {
                                        setSelectedStatus(e.target.value)
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="draft">پیشنویس</option>
                                    <option value="publish">منتشر شده</option>
                                    <option value="private">خصوصی</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">وضعیت موجودی</span>
                                <select
                                    onChange={ (e) => {
                                        setSelectedStockStatus(e.target.value)
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="in_stock">دارد</option>
                                    <option value="out_stock">ندارد</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">فروشگاه</span>
                                <ShopSelect
                                    hasFrontEnd={true}
                                    multiple={true}
                                    assignItem={handleMultiSelectShop}
                                placeholder="انتخاب فروشگاه"
                            />
                            </label>
                        </div>

                        <div className="flex items-end gap-2 sm:col-span-2 2xl:col-span-2">
                            <button onClick={ () => {
                                SetFilterQuery({
                                    category: selectedCategory,
                                    brand_value:selectedBrand,
                                    status: selectedStatus,
                                    state: selectedStockStatus,
                                    shop_id: selectedShop,
                                    created_by: selectedCreatedBy,
                                    updated_by: selectedUpdatedBy,
                                    published_by: selectedPublishedBy
                                })
                            } } className="btn-orange flex-1 whitespace-nowrap py-2">اعمال فیلتر</button>
                            <button onClick={clearFilters} className="btn-gray flex-1 whitespace-nowrap py-2">پاک کردن فیلترها</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
